/** @format */

"use client"; //this is a client side component

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import ApiInstance from "./instance";
import { SortFunctionForTabs } from "../../Utils";

const initialState = {
    isLoading: false,
    formError: null,
    form: null,
    originalTabs: null,

};

export const formSlice = createSlice({
    name: "form",
    initialState,
    reducers: {

        addOriginalTabs: (state, action) => {

            state.originalTabs = SortFunctionForTabs(action.payload);
        },


    },
    extraReducers: (builder) => {
        builder.addCase(getForm.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getForm.fulfilled, (state, action) => {
            state.isLoading = false;

            state.form = SortFunctionForTabs(action.payload)

        });
        builder.addCase(getForm.rejected, (state, action) => {
            state.isLoading = false;
            state.formError = action.payload;
        });

    },
});

export const getUsers = createAsyncThunk("user/getUser", async (data, thunkAPI) => {
    const url = `https://jsonplaceholder.typicode.com/posts`;
    try {
        const resp = await axios.get(url, data);
        return resp.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.response?.data?.message);
    }
});

export const getForm = createAsyncThunk("form//getForm", async (data, thunkAPI) => {

    return ApiInstance("get-form", "get", data, thunkAPI);
});
export const { addOriginalTabs } = formSlice.actions;

export default formSlice.reducer;
